import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
  {
    path: '/',
    redirect: 'gestao-periodo',
    component: LayoutPadrao,
    children: [
      {
        path: '/gestao-periodo/:matricula?/:referencia?',
        name: 'gestao-periodo',
        component: () => import('../pages/GestaoPeriodos.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'gestao-periodo',
    component: LayoutPadrao,
    children: [
      {
        path: '/gestao-periodo/:matricula/:referencia',
        name: 'gestao-periodo-voltar',
        component: () => import('../pages/GestaoPeriodos.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'gestao-periodo/detalhes-atividade',
    component: LayoutPadrao,
    children: [
      {
        path: '/gestao-periodo/detalhes-atividade/:id/:matricula/:referencia/:contratoId',
        name: 'gestao-periodo/detalhes-atividade',
        component: () => import('../pages/DetalhesAjustesConsultasFrequencia.vue')
      }
    ]
  }
]
